import type { ComponentProps } from 'react';
import { Icon } from 'ui';
import type { PollTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: PollTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const PollTodoWidgetItem = ({ className, todo, type }: P) => (
  <BaseTodoWidgetItem
    additionalDescription={todo.poll.description}
    className={className}
    description={todo.poll.title}
    icon={<Icon icon="list-check" />}
    path={todo.path}
    timeConfig={{ options: { display: 'time', mode: 'by' }, time: todo.endTime }}
    title="Complete poll"
    type={type}
  />
);

export default PollTodoWidgetItem;
